import { AppState } from '@/store/state';
import { ToggleSidebarMenu } from '@/store/ui/actions';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, HostListener, OnInit, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
    @HostBinding('class') class = 'wrapper';
    public ui: Observable<UiState>;
    public getScreenWidth: any;
    public menuSidebarCollapsed;

    constructor(private renderer: Renderer2, private store: Store<AppState>) {

    }

    ngOnInit() {
        this.getScreenWidth = window.innerWidth;
        this.ui = this.store.select('ui');
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'login-page'
        );

        this.ui.subscribe(
            ({ menuSidebarCollapsed, controlSidebarCollapsed, darkMode }) => {
                this.menuSidebarCollapsed = menuSidebarCollapsed;

                if (menuSidebarCollapsed) {
                    this.renderer.removeClass(
                        document.querySelector('body'),
                        'sidebar-open'
                    );
                    this.renderer.addClass(
                        document.querySelector('body'),
                        'sidebar-collapse'
                    );
                } else {
                    this.renderer.removeClass(
                        document.querySelector('body'),
                        'sidebar-collapse'
                    );
                    this.renderer.addClass(
                        document.querySelector('body'),
                        'sidebar-open'
                    );
                }

                /* if (controlSidebarCollapsed) {
                    this.renderer.removeClass(
                        document.querySelector('app-root'),
                        'control-sidebar-slide-open'
                    );
                } else {
                    this.renderer.addClass(
                        document.querySelector('app-root'),
                        'control-sidebar-slide-open'
                    );
                }*/

                if (darkMode) {
                    this.renderer.addClass(
                        document.querySelector('body'),
                        'dark-mode'
                    );
                } else {
                    this.renderer.removeClass(
                        document.querySelector('body'),
                        'dark-mode'
                    );
                }
            }
        );

        if (this.getScreenWidth < 1440) {
            if (!this.menuSidebarCollapsed) this.store.dispatch(new ToggleSidebarMenu());
            this.renderer.removeClass(
                document.querySelector('body'),
                'layout-footer-fixed'
            );
        } else {
            if (this.menuSidebarCollapsed) this.store.dispatch(new ToggleSidebarMenu());
            this.renderer.addClass(
                document.querySelector('body'),
                'layout-footer-fixed'
            );
        }

    }

    @HostListener('window:mouseup', ['$event'])
    onMouseUp(event) {
        if (this.getScreenWidth < 1440) {
            const container = document.querySelector(".main-sidebar")
            const objetivo = event.target as HTMLElement;
            if (!container?.contains(objetivo) && !this.menuSidebarCollapsed) {
                this.store.dispatch(new ToggleSidebarMenu());
            };
        }
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.getScreenWidth = window.innerWidth;
        if (this.getScreenWidth < 1440) {
            if (!this.menuSidebarCollapsed) this.store.dispatch(new ToggleSidebarMenu());
            this.renderer.removeClass(
                document.querySelector('body'),
                'layout-footer-fixed'
            );
        } else {
            if (this.menuSidebarCollapsed) this.store.dispatch(new ToggleSidebarMenu());
            this.renderer.addClass(
                document.querySelector('body'),
                'layout-footer-fixed'
            );
        }
    }

    onToggleMenuSidebar() {
        this.store.dispatch(new ToggleSidebarMenu());
    }
}
